<div *ngIf="platformControl.value as platform">
  @if (isInAddMode || platform === 'devices') {
    <div class="title" [innerHTML]="'integrationPage.addModeAuthMethodField' | requiredFieldTitle"></div>
  } @else {
    <div class="title">
      {{ 'integrationPage.editModeAuthMethodField' | labelsProvider }}: {{ selectedAuthMethodDisplayName }}
    </div>
  }

  <mat-radio-group [formControl]="authMethodControl">
    <mat-radio-button
      *ngFor="let authMethodOption of platformToAuthenticationMethodsSelectOptions[platform]"
      (click)="$event.stopPropagation()"
      [value]="authMethodOption.id"
      [disabled]="authMethodOption.disabled"
    >
      {{ authMethodOption.displayName | labelsProvider }}
      @if (authMethodOption.disabled) {
        <span class="deprecated-label">
          {{ 'integrationPage.authMethodDeprecatedLabel' | labelsProvider }}
        </span>
      }
    </mat-radio-button>
  </mat-radio-group>
</div>
